module.exports = __webpack_public_path__ + "static/media/logo.bb414d53.webp";